export const generateBase64Content = (file: File) => {
  const reader = new FileReader();

  return new Promise((resolve, reject) => {
    reader.onload = (event: ProgressEvent<FileReader>) => {
      const fileContentBase64 = event.target?.result?.toString().split(",")[1];
      resolve(fileContentBase64);
    };

    reader.onerror = (error) => {
      reject(error);
    };

    reader.readAsDataURL(file);
  });
};

export interface IUploadDataItem {
  id: any;
  fileContent: unknown;
  s3Key: string;
}

export const generateUploadImageData = async (
  store: string,
  files: File[] = [],
): Promise<{ uploadData: IUploadDataItem[] | null; isTooLarge: boolean }> => {
  const uploadData: IUploadDataItem[] = [];

  const MAX_BODY_SIZE_MB = 6; // Lambda Function URL 최대 body 용량

  await Promise.all(
    files.map(async (file, index) => {
      const fileContentBase64 = await generateBase64Content(file);
      uploadData.push({
        id: index,
        fileContent: fileContentBase64,
        s3Key: `${store}/${Date.now()}_${file.name}`,
      });
    }),
  );

  const bodySizeMB = new Blob([JSON.stringify(uploadData)]).size / 1024 / 1024;
  if (bodySizeMB > MAX_BODY_SIZE_MB) {
    return { uploadData: null, isTooLarge: true };
  }

  return { uploadData, isTooLarge: false };
};

export const resizeImage = (src: string, resolution: number) => {
  return src
    .replace(".jpg", `_${resolution}x.jpg`)
    .replace(".png", `_${resolution}x.png`)
    .replace(".webp", `_${resolution}x.webp`)
    .replace(".gif", `_${resolution}x.gif`)
    .replace(".avif", `_${resolution}x.avif`);
};
